export default __webpack_public_path__ + "static/media/luxsombra.3bed81d7.png";